export default __webpack_public_path__ + "static/media/flame_icon.34941ef1.svg";